import type { UserCompanyWithRole } from '@shared/api/graphql/generated';

export const AUDIO_REPORT_SCOPE = {
  COMMON: 'common',
  ADDRESSES: 'addresses',
  PROMOS: 'promos',
} as const;

export type AudioReportScopeType = (typeof AUDIO_REPORT_SCOPE)[keyof typeof AUDIO_REPORT_SCOPE];

export const PROMO_SELECTOR_LAYOUT = {
  EXPANDED: 'expanded',
  SINGLE_RESULT: 'single-result',
  EMPTY: 'empty',
} as const;

export type PromoSelectorLayout = (typeof PROMO_SELECTOR_LAYOUT)[keyof typeof PROMO_SELECTOR_LAYOUT];

export type ReportAddressTagType = {
  id: string;
  title: string;
};

export type ReportAddressType = {
  id: string;
  address: string;
  comment?: string;
  tags: ReportAddressTagType[];
};

export type ReportRecipientType = Pick<UserCompanyWithRole, 'email' | 'id'>;
